/* eslint-disable ember/no-classic-components, ember/no-component-lifecycle-hooks, ember/require-tagless-components */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { action } from '@ember/object';
import { service } from '@ember/service';

export default class TillSelector extends Component {
  @service
  finance;

  @tracked disabled = false;

  // The form to register the rendered field with, so it counts towards the
  // form's validity.
  parentComponent = null;

  get required() {
    return !this.disabled;
  }

  @tracked loading = true;

  didInsertElement() {
    super.didInsertElement(...arguments);
    this.finance.updateTillSessions().then(() => (this.loading = false));
  }

  @action
  setTill(till) {
    this.finance.setTill(till);
  }
}
